import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IsThisProductSuitableForMe } from '../../products/products/common/is_this_product_suitable_for_me';

const useStyles = createUseStyles((theme) => ({
    icon: {
        marginLeft: '0.5rem'
    },
    link: {
        fontWeight: theme.fontWeight.bold
    }

}));

const linkText = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    return (
        <div className={classes.link}>
            See details
            {' '}
            <FontAwesomeIcon icon={faFile} className={classes.icon} />
        </div>
    );
};

const SuitableCell = ({ product }) => {
    return (
        // eslint-disable-next-line react/no-children-prop
        <IsThisProductSuitableForMe quote={product}>{linkText()}</IsThisProductSuitableForMe>
    );
};

SuitableCell.propTypes = {
    product: PropTypes.object
};

export { SuitableCell };
